module.exports = __webpack_public_path__ + "img/21-green.68fc2122.svg";